import { useEffect, useRef } from 'react';

interface Props {
  message: string | null;
  durationMs?: number;
  onDismiss: () => void;
}

/**
 * Fire-and-forget success toast for Settings mutations. Unlike UndoToast,
 * there's no Undo affordance — settings mutations aren't reversible via a
 * single click. Auto-dismisses after `durationMs`. Uses the same pill
 * styling as UndoToast (`.undo-toast`) + a success variant class.
 */
export function SettingsToast({ message, durationMs = 3500, onDismiss }: Props) {
  const dismissRef = useRef(onDismiss);
  dismissRef.current = onDismiss;

  useEffect(() => {
    if (!message) return;
    const t = setTimeout(() => dismissRef.current(), durationMs);
    return () => clearTimeout(t);
  }, [message, durationMs]);

  if (!message) return null;
  return (
    <div className="undo-toast settings-success-toast" role="status">
      <span>{message}</span>
    </div>
  );
}
